import React from "react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
    isWidgetOpenSelector,
    mainColourSelector,
    messagesSelector,
    openChatbot,
    saveInitialBotMessage,
    updateInitializationType
} from "../chatbotSlice";
import {InitializationType} from "../../api/generated";

const hexToRgb = (hex: string): string => {
    const [, r, g, b] = hex.match(/^#?(\w\w)(\w\w)(\w\w)$/)!;
    return `${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}`;
}

export const WidgetBubble: React.FC = () => {
    const dispatch = useAppDispatch();
    const isWidgetOpen = useAppSelector(isWidgetOpenSelector);
    const messages = useAppSelector(messagesSelector);
    const mainColour = useAppSelector(mainColourSelector);
    const mainRgb = hexToRgb(mainColour)

    const openBot = () => {
        dispatch(openChatbot());
        if (messages.length == 0) {
            dispatch(saveInitialBotMessage())
        }
        dispatch(updateInitializationType(InitializationType.OnWidgetClick))
    };

    return <div
        className={`cursor-pointer rounded-full backdrop-blur z-20 w-fit h-[80px] shadow-smooth-6 transition-transform transform duration-500 ease-in-out ${
            !isWidgetOpen ? "scale-100 animate-pulse" : "scale-0"
        }`}
        style={{"--pulse-rgb": mainRgb} as React.CSSProperties}
        onClick={openBot}
    >
        <div
            className={`relative rounded-full w-full h-full border-2 border-white flex items-center justify-center transition duration-200 ease-in-out hover:scale-105`}
            style={{height: "80px", width: "80px", backgroundColor: mainColour}}>
            <img
                id="bot-logo"
                itemProp="bot logo"
                alt="Bot Logo"
                width={44}
                height={42}
                src='/motor-tech-logo-white.svg'
                className="w-full"
                style={{height: "44px", width: "42px"}}
            />
        </div>
    </div>
}
